const question = {
    '0-1': { point: [1], resolvedProfile: 'P' },
    '1-3': { point: [1], resolvedProfile: 'P' },
    '3-5': { point: [2], rejectedProfiles: ['D'] },
    '5+': { point: [2] },
    '8+': { point: [3] },
};

export default question;
